import { render, staticRenderFns } from "./OurConfirmationDialog.vue?vue&type=template&id=08bde840&"
import script from "./OurConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./OurConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports